import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Row, Col,Input,Checkbox,Table,Popover,Icon} from 'antd';
import '../resourcePool.css';
import {VIDEO_TYPE} from '../../../../../constants';
import smallLock from '../img/smallLock.png'
import defaultImg from  '../img/default.png'
import {unitConvert} from "../../../../../utils";
import play from '../img/play.png'


export default class File extends Component {
		static defaultProps = {checked:true,
		title:'fdfdfdfdfdfdfdfdfdfssssssss',
		type:'list',
		img:'images/folder.png',
		createTime:'2020-12-22 16:10:11',
		IsDownLoad:false,
		onClick:()=>{
			console.log('双击')
		},
		IsChecked:()=>{

			}
		};
     static propTypes = {
		 title:PropTypes.string.isRequired,//传入dom 结构
		 type:PropTypes.string.isRequired,//small  middle, big ,list
		 checked:PropTypes.bool,//是否选中
		 img:PropTypes.string.isRequired,//传入图标
		 onClick:PropTypes.func.isRequired,//双击函数
		 IsChecked: PropTypes.func.isRequired,//选中的函数
		 IsDownLoad:PropTypes.bool,//是否能下载
		};
    constructor(props) {
        super(props);
        this.state = {
			hover:false
		}		
    }
    componentWillMount() {
    }
    componentDidMount() {
    }	
    handleEnter() {
       this.setState({ hover:true })
     }
     handleOut() {
       this.setState({ hover:false })
     }	
    render(){
// 鼠标点击划过  公共
		let backgroundColor;
		let isHover;
		if(this.props.checked){
			 backgroundColor='rgba(0, 80, 179, 0.04)'
			 isHover ='block'
		}else{
			backgroundColor='#ffffff' ;
			isHover ='none'
			if (this.state.hover) {
				backgroundColor='rgba(0, 80, 179, 0.04)';
				isHover ='block'
			} else {
				backgroundColor= 'white';
				isHover ='none'
			}
		}
		return(
			<div style={{cursor:'pointer',}} >
				{this.renderFileCard(backgroundColor,isHover)}
			</div>)
		
		}
		//渲染小 中，大
		renderFileCard(backgroundColor,isHover){

			let width,height,picW,picH,fontsize;
			if(this.props.type==='small'){
				width=140;height=140;picW=56;picH=56
			}else if(this.props.type==='middle'){
				width=200;height=200;picW=100;picH=100;fontsize=18
			}else if(this.props.type==='big'){
				width=300;height=300;picW=150;picH=150;fontsize=25
			}
			let resource = <div>{this.props.btnNames.length>0?<div style={{display:isHover,position:'absolute',width:"35px",height:"35px",top:0,right:0,borderRadius: "0px 16px 0px 0px"}}
																   onClick={(e)=>{
																	   this.props.IsChecked&&this.props.IsChecked(!this.props.checked)}}>
				<Checkbox  checked={this.props.checked} style={{position:'relative',right:2,top:6}}  ></Checkbox>
			</div>:null}</div>;

			let editor =<div>{this.props.IsShowChecked==='FILE'?<div style={{display:isHover,position:'absolute',width:"35px",height:"35px",top:0,right:0,borderRadius: "0px 16px 0px 0px"}}
																onClick={(e)=>{
																	this.props.IsChecked&&this.props.IsChecked(!this.props.checked)}}>
				<Checkbox  checked={this.props.checked} style={{position:'relative',right:2,top:6}}  ></Checkbox>
			</div>:null}</div>;
			return(
			<div style={{width:width,height:height,textAlign:'center',paddingTop:11,background:backgroundColor,borderRadius:'16px',margin:'0px 5px 9px 5px',float:'left',position: 'relative'}}
				 onMouseOver ={() => this.handleEnter()}
				 onMouseOut= {() => this.handleOut()}>
				<div onClick={()=>{
					this.props.doubleClick&&this.props.doubleClick()
				}}>
					<div style={{position: 'relative'}}>
						<img src={this.props.img?this.props.img:defaultImg} style={{width:picW,height:picH,objectFit:'contain'}}/>
						{VIDEO_TYPE.indexOf(this.props.suffix)>-1? <img src={play} style={{
							position:'absolute',
							top:'50%',
							left:'50%',
							cursor: "pointer",
							marginLeft: '-15px',
							marginTop: '-16px',
							zIndex:1,
							fontSize:'16px',
							color:'#ffffff'}} />:null}
					</div>

					<div style={{padding:'0 10px',color:"rgba(0, 0, 0, 0.65)"}} >
						<div title={this.props.title}  className={'twoText'}  style ={{fontSize:fontsize,overflow: 'hidden',textOverflow:'ellipsis'}}>{this.props.title}</div>
						<div  style ={{fontSize:fontsize,overflow: 'hidden',textOverflow:'ellipsis'}}>{this.props.IsShowChecked==='FILE'?unitConvert(this.props.size):this.props.createTime}</div>
					</div>
				</div>
				{this.props.IsDownLoad? <img src={smallLock} style={{
					position:'absolute',
					zIndex:10,
					top:7,
					left:7,
					fontSize:'16px',
					color:'#ffffff'}} />:null}

				{
					this.props.isEditor?editor:resource
				}

				{/*{this.props.IsDownLoad?<img sr={'lock'}><Icon type="lock" style={{position:'absolute',right:10,bottom:10}}/>:null}*/}

			</div>
			)
		}
}